import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useAemConfig } from '@as-react/common-components';
import CustomerApi from '../../api/customer/CustomerApi';
import { AccountCreditCard } from '../../components/account/account-credit-card/AccountCreditCard';
const AccountCreditCardContainer = ({ title }) => {
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const [creditCards, setCreditCards] = useState(null);
    const fetchCreditCards = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const data = yield CustomerApi.getCardInfo(servicesEndpoint, defaultRequestParams);
            setCreditCards(data);
        }
        catch (_a) { }
    });
    const removeCard = (cardId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield CustomerApi.deleteCard(servicesEndpoint, defaultRequestParams, cardId);
            fetchCreditCards();
        }
        catch (_a) { }
    });
    useEffect(() => {
        fetchCreditCards();
    }, []);
    return _jsx(AccountCreditCard, { ogoneAliases: creditCards, removeCard: removeCard, title: title });
};
export default AccountCreditCardContainer;
